export default __webpack_public_path__ + "static/media/celebrate.c3415f4aead3d6748542607349ce8259.svg";